module.exports = __webpack_public_path__ + "img/1.6bc9c21b.png";